import { isMatchAbbreviation } from "../Types";
import { isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";

import { FiasRoomTypes } from "./RoomTypes";

export function getRoomTypeLongName(roomType: string | number | undefined): string | undefined {
    const stringFlatType = roomType?.toString();
    const roomName = FiasRoomTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.long;
    if (isNullOrEmpty(roomName)) {
        return undefined;
    }
    return roomName;
}

export function getRoomTypeShortName(roomType: string | number | undefined): string | undefined {
    const stringFlatType = roomType?.toString();
    const roomName = FiasRoomTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.short;
    if (isNullOrEmpty(roomName)) {
        return undefined;
    }
    return roomName;
}
